import * as React from 'react';


class NavBar extends React.Component <any, any> {
    constructor(props:any){
        super(props);
        this.state={
            className:'nav-roxo navbar-dark',
            logo: require("../css/img/syligo-logo.png")
        };
    }

    handleScroll(){
        if(document.documentElement.scrollTop > 680){
            this.setState({
                className:'navbar-light nav-branco',
                logo: require("../css/img/syligo-logo-color.png")
            })
        }
        else{
            this.setState({
                className:'navbar-dark nav-roxo',
                logo: require("../css/img/syligo-logo.png")
            })
        }
    }

   
    componentDidMount(){
        window.onscroll = () => this.handleScroll();
    }
    
    

    render(){
        return( 
            <nav id="nav-bar" className={`navbar navbar-expand-lg fixed-top ${this.state.className}`}>
                <a href="" className="navbar-brand">
                    <img src={this.state.logo} alt="" className="" height="40"/>
                </a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse navbar-right" id="navbarSupportedContent">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <a className="nav-link upper" href="#sobre">Sobre<span className="sr-only">(current)</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link upper" href="#portfolio">Portfólio<span className="sr-only">(current)</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link upper" href="#reconhecimento">Reconhecimento <span className="sr-only">(current)</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link upper" href="#servicos">Serviços <span className="sr-only">(current)</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link upper" href="#equipe">Equipe <span className="sr-only">(current)</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link upper" href="#contato">Contato <span className="sr-only">(current)</span></a>
                        </li>
                    </ul>
                </div>
            </nav> 
        );
    }
};
export default NavBar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NavBarComponent.tsx